export default {"src":"/assets/turbo/3c4013c1/ottoversandat/_next/static/media/favicon.7395fa3b.ico","height":32,"width":32,"blurWidth":0,"blurHeight":0};